export default "__VITE_ASSET__Bh3xfNH8__"